import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";

export default {
  name: "position-history",
  components: {
    AppHeader
  },
  created() {
    this.getUser();
    this.getPositionHistory();
  },
  data() {
    return {
      getPositionHistoryEnd: false,
      positionHistories: [],
      errorInfo: "",
      user: ""
    };
  },
  methods: {
    async getUser() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_USER", {
          id: this.$route.params.user_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.user = res.user;
    },
    authorityCheck() {
      if (localStorage.user_authority == 2) {
        // 役員でログイン
        return false;
      }
      return true;
    },
    async getPositionHistory() {
      this.getPositionHistoryEnd = false;
      let data = {
        user_id: this.$route.params.user_id
      };
      let res = await this.$store
        .dispatch("GET_POSITION_HISTORY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.positionHistories = res.position_histories;
      this.getPositionHistoryEnd = true;
    },
    deleteModal(positionHistoryId) {
      this.cancelPositionHistoryId = positionHistoryId;
      this.$bvModal.show("modal-delete");
    },
    async cancelPositionHistory() {
      let res = await this.$store
        .dispatch("DELETE_POSITION_HISTORY", {
          id: this.cancelPositionHistoryId,
          data: {}
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (!res.error) {
        window.alert("元の役職に戻ったら権限も戻ります。確認してください。");
        this.getPositionHistory();
      } else {
        this.errorInfo = res.error;
      }
      this.$bvModal.hide("modal-delete");
    },
    formatDate(date) {
      return dayjs(date).format("YYYY年MM月DD日");
    },
    goUserDetail() {
      this.$router.push({ path: `/user/${this.$route.params.user_id}` });
    },
    goPositionHistoryNew() {
      this.$router.push({
        path: `/position_history/${this.$route.params.user_id}/new`
      });
    },
    goPositionHistoryForceEdit() {
      this.$router.push({
        path: `/position_history/${this.$route.params.user_id}/force_edit`
      });
    }
  }
};
